import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <>
      <CountdownTimer data-id="element-151" />

      <Section bg="dark-900" className="pt-8 pb-12 md:pt-16 md:pb-24" data-id="element-152">
        <div className="max-w-4xl mx-auto space-y-4 md:space-y-8" data-id="element-153">
          {/* Standard Plan Final CTA */}
          <div className="bg-dark-800 border border-dark-700 rounded-2xl p-5 md:p-8 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6" data-id="element-154">
            <div className="text-center md:text-left" data-id="element-155">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-1 md:mb-2" data-id="element-156">
                <span className="text-xl md:text-2xl" data-id="element-157">📘</span>
                <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-158">
                  FUNCIONAL & CROSS 360
                </h3>
              </div>
              <p className="text-gray-400 text-xs md:text-sm mb-2" data-id="element-159">
                6 Tomos + 6 Bonos
              </p>
              <div className="flex items-baseline justify-center md:justify-start gap-2 md:gap-3" data-id="element-160">
                <span className="text-gray-500 line-through text-xs md:text-sm" data-id="element-161">
                  Antes: $34.990 ARS
                </span>
                <span className="text-xl md:text-2xl font-display font-bold text-white" data-id="element-162">
                  Hoy: $19.990 ARS
                </span>
              </div>
            </div>
            <div className="w-full md:w-auto flex flex-col items-center gap-2" data-id="element-163">
              <Button href="https://checkout.rincondigital.shop/cart/54042948501779:1" variant="secondary" className="w-full md:w-auto whitespace-nowrap" data-id="element-164">
                QUIERO MI FUNCIONAL & CROSS 360
              </Button>
              <span className="text-[10px] md:text-xs text-gray-500 font-bold uppercase tracking-wider" data-id="element-165">
                La más elegida ⭐
              </span>
            </div>
          </div>

          {/* Elite Plan Final CTA */}
          <div className="bg-gradient-to-r from-dark-800 to-dark-900 border border-lime-500 rounded-2xl p-5 md:p-8 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 shadow-[0_0_30px_rgba(204,255,0,0.1)]" data-id="element-166">
            <div className="flex-1 text-center md:text-left" data-id="element-167">
              <div className="flex flex-col md:flex-row items-center justify-center md:justify-start gap-1 md:gap-2 mb-1 md:mb-2" data-id="element-168">
                <span className="text-xl md:text-2xl" data-id="element-169">🏆</span>
                <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-170">
                  FUNCIONAL & CROSS 360{' '}
                  <span className="text-lime-400 block md:inline" data-id="element-171">
                    + ELITE COACH 360™
                  </span>
                </h3>
              </div>
              <p className="text-gray-400 text-xs md:text-sm mb-3 md:mb-4" data-id="element-172">
                6 Tomos + 6 Bonos + Elite Coach 360™ <br data-id="element-173" />
                <span className="text-[10px] md:text-xs" data-id="element-174">
                  (Guía completa de adaptaciones, periodización avanzada, WODs
                  de competencia y protocolo de emergencia)
                </span>
              </p>
              <div className="flex items-baseline justify-center md:justify-start gap-2 md:gap-3" data-id="element-175">
                <span className="text-gray-500 line-through text-xs md:text-sm" data-id="element-176">
                  Antes: $43.990 ARS
                </span>
                <span className="text-2xl md:text-3xl font-display font-bold text-lime-400" data-id="element-177">
                  Hoy: $27.990 ARS
                </span>
              </div>
            </div>
            <div className="w-full md:w-auto" data-id="element-178">
              <Button href="https://checkout.rincondigital.shop/cart/54043001291027:1" variant="primary" size="lg" className="w-full md:w-auto whitespace-nowrap" data-id="element-179">
                QUIERO EL PACK ELITE
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-6 md:mt-8 text-xs md:text-sm text-gray-400 font-medium" data-id="element-180">
            <span data-id="element-181">Pago 100% seguro</span>
            <span className="hidden md:inline" data-id="element-182">•</span>
            <span data-id="element-183">Acceso en 5 minutos</span>
            <span className="hidden md:inline" data-id="element-184">•</span>
            <span data-id="element-185">Garantía 7 días sin preguntas</span>
            <span className="hidden md:inline" data-id="element-186">•</span>
            <span data-id="element-187">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </Section>
    </>;
}